import { useState } from "react";
import "./works.scss";

export default function Works() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const aboutMeLeft = {
    marginLeft: "3rem",

  }


  const data = [
    {
      id: "1",
      icon: "./assets/mobile.png",
      title: "FrontEnd",
      desc:
        "HTML, CSS, JavaScript, React, Redux, Bootstrap",
      img:
        "./assets/frontend.png",
    },
    {
      id: "2",
      icon: "./assets/globe.png",
      title: "BackEnd",
      desc:
        "NodeJs, Express, MongoDB, SQL",
      img:
        "./assets/backend.png",
    },
    {
      id: "3",
      icon: "./assets/writing.png",
      title: "Extra",
      desc:
        "CLI Bash, Json, VS Code, Postman, Eclipse",
      img:
        "./assets/extra.png",
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };

  return (
    <>
      {/* <div className="works" > */}
      <div className="works" id="aboutMe">

        <div className="aboutMe" style={{



          position: "absolute",
          top: "0px"



        }}>

          <h1
            style={{
              // textAlign: "center",
              // margin: "1rem",
              // fontSize: "2.8rem"
              fontSize: "2.6rem"
            }}
          >About Me</h1>
          <h3
          // style={{
          //   textAlign: "center",
          //   // marginBottom: "1rem",
          //   // width: "80%"
          //   paddingLeft: "2rem",
          //   paddingRight: "2rem",
          //   fontSize: "1.4rem",
          //   marginBottom: "11.5rem"
          //   // paddingBottom: "2rem"

          // }}
          // className="aboutMe"
          >Self motivated Full Stack developer strong in pixel-perfect website creation with intuitive problem-solving skills.<br /><span id="aboutMeExtra"> Proficient in JavaScript, HTML, CSS,MongoDB and ReactJs. Passionate about implementing and launching new web apps.<br />

              {/* <br /> */}
              <h1 className="skillsPara" style={{
                textAlign: "center",
                marginTop: "1rem",


              }} ><span className="skillsPara" >Skills</span></h1>
              <br />


            </span>

          </h3>

        </div>

        {/* <div className="works" id="works"> */}
        <div
          className="slider"
          style={{
            transform: `translateX(-${currentSlide * 100}vw)`,
            marginTop: "12rem"
          }}
        >

          {data.map((d) => (
            <div className="container">
              <div className="item">
                <div className="left">
                  <div className="leftContainer">
                    {/* <div className="imgContainer"> */}
                    {/* <img src={d.icon} alt="" /> */}
                    {/* </div> */}
                    <div className="aboutMeLeft">
                      <h1>{d.title}</h1>
                      <p> <br /></p>
                      <h2 className="h2Desc">{d.desc}</h2>
                    </div>
                    {/* <span>Projects</span> */}
                  </div>
                </div>
                <div className="right">
                  <img
                    src={d.img}
                    alt=""
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <img
          src="assets/arrow.png"
          className="arrow left"
          alt=""
          onClick={() => handleClick("left")}
          style={{
            marginTop: "6rem",
            // background: "red"
          }}
        /> <img
          src="assets/blackarrowleft.png"
          className="arrowleft"
          alt=""
          onClick={() => handleClick("left")}
        />
        <img
          src="assets/arrow.png"
          className="arrow right"
          alt=""
          onClick={() => handleClick()}
          style={{
            marginTop: "6rem",
            // background: "red"
          }}
        />
        <img
          src="assets/blackarrowright.png"
          className="arrowright"
          alt=""
          onClick={() => handleClick()}
        />
      </div>
    </>
  );
}
